import makeStyles from "@material-ui/core/styles/makeStyles";
import Filter from "@saleor/components/Filter";
import { IFilter } from "@saleor/components/Filter/types";
import SearchInput from "@saleor/components/SearchBar/SearchInput";
import React from "react";

interface FilterBarProps<TKeys extends string = string> {
  currencySymbol: string;
  filterStructure: IFilter<TKeys>;
  initialSearch: string;
  searchPlaceholder: string;
  onSearchChange;
  onFilterChange;
}

const useStyles = makeStyles(
  theme => ({
    cameraButton: {
      alignItems: "center",
      cursor: "pointer",
      paddingLeft: "5px",
      position: "absolute",
      right: "12px",
      top: "6px",
      zIndex: 9
    },
    cameraButtonImg: {
      width: "30px"
    },
    filterStatus: {
      "& .MuiTabs-scroller.MuiTabs-fixed": {
        overflowX: "scroll"
      }
    },
    root: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      display: "flex",
      flexWrap: "wrap",
      padding: theme.spacing(1, 3)
    },
    searchForm: {
      "& input[type=text]": {
        paddingRight: "52px"
      },
      display: "flex",
      flex: 1,
      position: "relative"
    },
    tabActionButton: {
      marginLeft: theme.spacing(2),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }
  }),
  {
    name: "FilterBar"
  }
);

const FilterBar: React.FC<FilterBarProps> = props => {
  const {
    currencySymbol,
    filterStructure,
    initialSearch,
    searchPlaceholder,
    onSearchChange,
    onFilterChange
  } = props;

  const classes = useStyles(props);

  return (
    <>
      <div className={classes.root}>
        <Filter
          currencySymbol={currencySymbol}
          menu={filterStructure}
          onFilterAdd={onFilterChange}
        />
        <div className={classes.searchForm}>
          <SearchInput
            initialSearch={initialSearch}
            placeholder={searchPlaceholder}
            onSearchChange={onSearchChange}
          />
        </div>
      </div>
    </>
  );
};
FilterBar.displayName = "FilterBar";
export default FilterBar;
